import {commonWebSocket} from '@services/common/common.constants';
import {createReducer} from 'redux-act';

const defaultState = {
  experts: [],
};

const reducer = createReducer<typeof defaultState>({}, defaultState);

reducer
  .on(commonWebSocket.snapshot.EXPERT_SNAPSHOT, (state:any, payload:any) => {
    if (Array.isArray(payload?.experts)) {
      return {
        ...state,
        experts: payload.experts.filter((expert: any) => expert && typeof expert === "object"),
      };
    }
    return state;
  });

export default reducer;



// WEBPACK FOOTER //
// ./src/services/expert/expert.reducer.ts